import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from 'components/Shared/EmptyState/EmptyState';

var Notifications = function () {
  var t = useTranslation().t;
  return (
    <EmptyState
      icon="notifications_active"
      title={t('inspect:notificationsEmptyTitle')}
      description={t('inspect:notificationsEmptyDescription')}
    />
  );
};

export default Notifications;
